import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface CompanyNamesSearch {
  companyType: string;
  name: string;
  timestamp: number;
}

const initialState = {} as CompanyNamesSearch;

const searchConditionSlice = createSlice({
  name: "companyName",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<CompanyNamesSearch>
    ) => {
      const { companyType, name, timestamp } = action.payload;
      state.companyType = companyType;
      state.name = name;
      state.timestamp = timestamp;
    },
    clearSearchCondition: () => ({ ...initialState }),
  },
});

export const { createSearchCondition, clearSearchCondition } =
  searchConditionSlice.actions;

export default searchConditionSlice.reducer;
